import dayjs from "dayjs";
import {useMemo} from "react";
import {DATE_FORMAT_V2} from "../../helpers";

interface Props {
  date: string | number | Date | dayjs.Dayjs;
}

export const FormattedDate = ({date}: Props) => {
  const formatted = useMemo(() => {
    return dayjs(date).format(DATE_FORMAT_V2);
  }, [date]);

  return <span data-wg-notranslate>{formatted}</span>;
};
